/** @type {
 	(setId: string, plasmidId: string, length: number, base: number) =>
	(deps: { sgApiClient: import("../interfaces/ISGApiClient").ISGApiClient }) => Promise<string>
} */
const getPlasmidSequenceLine =
	(setId, plasmidId, length, base) =>
	({ sgApiClient }) =>
		sgApiClient.getSequenceLine(setId, plasmidId, length, base);

export default getPlasmidSequenceLine;
